export const AdminSettingsEndpoint = {
  adminSettings: "adminSettings",
  createBulkMessages: "adminSettings/createMultipleMessage",
  fileUpload: "file/upload",
};
export const FeedbackEndpoint = {
  feedback: "feedback",
};
